import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CreateNewPackageVersion from "components/CreateNewPackageVersion/CreateNewPackageVersion";

import styles from "./CreatePackageVersion.module.scss";

const handleOnClickGoBackButton = (navigate,packageGroupId) => {
  navigate(`/packageDetails?packageGroupId=${packageGroupId}`);
};

const CreatePackageVersion = () => {
  const [searchParams] = useSearchParams();
  const packageGroupId = searchParams.get("packageGroupId");
  const packageId = searchParams.get("packageId");
  const navigate = useNavigate();

  return (
    <div className={styles.mainContainer}>
      <div
        className={styles.backContainer}
        onClick={() => handleOnClickGoBackButton(navigate,packageGroupId)}
      >
        <ArrowBackIosIcon className={styles.icon} />
        <span className={styles.text}>Back</span>
      </div>
      <CreateNewPackageVersion packageGroupId={packageGroupId} packageId={packageId} />
    </div>
  );
};

export default CreatePackageVersion;
